export default __webpack_public_path__ + "static/media/8.2e83c20b.svg";